import { MsgExecuteContract } from "cosmes/client"
import { useWallet } from "providers/WalletProvider"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { formatNumber } from "utils/Functions"
import { querySmartContract } from "utils/RpcHelper"

export function BurnPage() {
    const navigate = useNavigate()
    const { burnAddress } = useParams()
    const [tokenAddress, setTokenAddress] = useState()
    const [tokenInfo, setTokenInfo] = useState<{ name: string, symbol: string }>()
    const [balance, setBalance] = useState<number>();
    const [amount, setAmount] = useState<string>();
    const { address, post } = useWallet()

    const loadTokenAddress = async () => {
        const { token_address } = await querySmartContract(burnAddress!, { token_address: {} })
        setTokenAddress(token_address)
    }

    useEffect(() => {
        loadTokenAddress()
    }, [])

    const loadTokenInfo = async () => {
        const res = await querySmartContract(tokenAddress!, { token_info: {} })
        setTokenInfo(res)
    }

    useEffect(() => {
        if (tokenAddress) loadTokenInfo()
    }, [tokenAddress])


    const loadBalance = async () => {
        const { balance } = await querySmartContract(tokenAddress!, { balance: { address } })
        setBalance(Number(balance ?? "0"))
    }

    useEffect(() => {
        if (address && tokenAddress) loadBalance()
    }, [address, tokenAddress])


    const burn = async () => {
        const amountNumber = Number(amount)
        if (!address) return alert("Please connect your wallet")
        if (!balance) return alert("You have no balance");
        if (amountNumber < 1 || amountNumber > balance)
            return alert(`The amount must be more than 0 and less than ${formatNumber((balance ?? 0) / 1e6)} ${tokenInfo?.symbol}`)


        try {
            const executeMsg = new MsgExecuteContract({
                sender: address,
                contract: tokenAddress!,
                funds: [],
                msg: {
                    send: {
                        contract: burnAddress,
                        amount: (amountNumber * 1e6).toString(),
                        msg: Buffer.from(JSON.stringify({
                            burn: {}
                        })).toString("base64")
                    }
                },
            })
            const txHash = await post({
                msgs: [executeMsg],
                memo: `Burn token ${tokenInfo?.symbol}`
            })

            navigate("/tx-loading/" + txHash)
        } catch (e) {
            console.log(e)
            alert("error: " + e + ", (PLEASE REPORT TO DEVELOPER)")
        }

    }

    return <div className="w-100 p-2 px-4">
        <h4>Burn token</h4>
        <p className="text-muted">Burn some amount from your balance</p>

        <div className="form-group">
            <label htmlFor="token-address">Amount</label>
            <input
                onChange={({ target }) => setAmount(target.value)}
                type="number"
                className="form-control"
                id="token-address"
                placeholder={`Enter some ${tokenInfo?.symbol}`} />
            <p className="mt-1 text-muted">Your balance: <span className="text-white">{formatNumber((balance ?? 0) / 1e6)} {tokenInfo?.symbol}</span></p>
        </div>
        <button type="button" onClick={() => burn()} className="btn btn-primary w-100 btn-lg">Burn</button>
        <button type="button" onClick={() => navigate("/leaderboard/" + burnAddress)} className="btn mt-2 btn-success w-100 btn-lg">Leaderboard</button>
    </div>
}